export default __webpack_public_path__ + "static/media/integrity.384e2e60.png";